function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Snackbar from "@mui/material/Snackbar";
import SnackbarContent from "@mui/material/SnackbarContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
//Limitless imports
import { withi18n } from "../../../customer/components";
class Toast extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "variantIcon", {
      success: CheckCircleIcon,
      error: ErrorIcon,
      info: InfoIcon
    });
    _defineProperty(this, "variantPosition", {
      info: {
        vertical: "top",
        horizontal: "center"
      },
      error: {
        vertical: "top",
        horizontal: "center"
      },
      success: {
        vertical: "top",
        horizontal: "center"
      }
    });
  }
  render() {
    const {
      classes,
      t,
      open,
      onClose,
      message,
      variant,
      duration,
      payload
    } = this.props;
    const Icon = this.variantIcon[variant];
    return /*#__PURE__*/React.createElement(Snackbar, {
      anchorOrigin: this.variantPosition[variant],
      open: open,
      autoHideDuration: duration,
      onClose: onClose,
      TransitionComponent: Fade,
      classes: {
        anchorOriginTopCenter: classes.snackBar
      }
    }, /*#__PURE__*/React.createElement(SnackbarContent, {
      classes: {
        root: classes.contentRoot
      },
      className: classes[variant],
      message: /*#__PURE__*/React.createElement("span", {
        id: "message-id",
        className: classes.message
      }, /*#__PURE__*/React.createElement(Icon, {
        className: `${classes.icon} ${variant === "info" ? classes.contentColor : ""}`
      }), /*#__PURE__*/React.createElement(Typography, {
        className: variant === "info" ? classes.contentColor : ""
      }, payload ? t(message, payload) : t(message)), /*#__PURE__*/React.createElement(IconButton, {
        classes: {
          root: variant === "info" ? classes.contentColor : ""
        },
        key: "close",
        color: "inherit",
        style: {
          padding: "4px"
        },
        "aria-label": "Close",
        onClick: onClose,
        size: "large"
      }, /*#__PURE__*/React.createElement(CloseIcon, null)))
    }));
  }
}
const styles = theme => ({
  snackBar: {
    top: 0,
    display: "flex"
  },
  contentRoot: {
    minWidth: 250
  },
  message: {
    minWidth: 250,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  icon: {
    opacity: 0.9,
    marginRight: theme.spacing(1)
  },
  success: {
    backgroundColor: "#4caf50"
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.background.default
  },
  contentColor: {
    color: theme.palette.primary.dark
  }
});
export default withStyles(styles)(withi18n(Toast));
Toast.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  actionButton: PropTypes.node,
  message: PropTypes.string.isRequired,
  payload: PropTypes.string,
  variant: PropTypes.string,
  duration: PropTypes.number
};
Toast.defaultProps = {
  variant: "info",
  duration: 6000
};